<template lang="pug">
  button.btn(@click="onClick" :disabled="disabled || spinning" :class="`btn-${buttonType}`")
    i.fa
      span(v-if="icon && !spinning" :class="`fa-${icon}`")
      .fa-cog.fa-spin.fa-fw(v-if="spinning")
    span.ml5(v-if="text && icon")
    span(v-if="text") {{ text }}
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Save'
    },
    icon: {
      type: String
    },
    buttonType: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    spinning: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    }
  }
}
</script>

<style lang="scss">
.ssp-action-button {
  display: inline-block
}
</style>



// WEBPACK FOOTER //
// src/components/global/SspActionButton.vue